import clsx from 'clsx'
import React from 'react'
import { Controller, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { ControlledCommons } from '../../input-text/input-text'
import { FilterBudgetTypeEnum } from '../../../../lib/graphql'

interface IHouseSearchFilterSwitchBudgetProps<T extends FieldValues>
  extends ControlledCommons<T> {
  label1?: string
  label2?: string
  forceAllInclusive: boolean
}

export const HouseSearchFilterSwitchBudget = <T extends FieldValues>({
  control,
  name,
  rules,
  label1,
  label2,
  forceAllInclusive,
}: IHouseSearchFilterSwitchBudgetProps<T>) => {
  return (
    <div className={s.container}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <div className={s.switch}>
            <div
              className={clsx(s.leftSwitch, {
                [s.selected]:
                  field.value === FilterBudgetTypeEnum.ALL_INCLUSIVE ||
                  forceAllInclusive,
                [s.disabled]: forceAllInclusive,
              })}
              onClick={() => {
                if (!forceAllInclusive) {
                  field.onChange(FilterBudgetTypeEnum.ALL_INCLUSIVE)
                }
              }}
            >
              <p>{label1}</p>
            </div>
            <div
              className={clsx(s.rightSwitch, {
                [s.selected]:
                  field.value === FilterBudgetTypeEnum.DRY_LOCATION &&
                  !forceAllInclusive,
                [s.disabled]: forceAllInclusive,
              })}
              onClick={() => {
                if (!forceAllInclusive) {
                  field.onChange(FilterBudgetTypeEnum.DRY_LOCATION)
                }
              }}
            >
              <p>{label2}</p>
            </div>
          </div>
        )}
      />
    </div>
  )
}
